import { gql } from "@apollo/client";

const DELETE_EVENT = gql`
  mutation deleteEvent($id: ID!) {
    deleteEvent(id: $id) {
      id
    }
  }
`;

export default DELETE_EVENT;
